import { useTranslation } from '@root/misc/useTranslation';
import React from 'react';

export const GermanLicenseInfo: React.FC<{count: number, max: number}> = ({ count, max }) => {
  const { t } = useTranslation();

  return <div className="neo__lineup__germanLicenseInfo">
    <h3>{t('lineup.german_license_info.title', {count, max})}</h3>
    <p>{t('lineup.german_license_info.info', {max})}</p>
  </div>
};
